import { CustomErrorLogger } from './utils/CustomErrorLogger';
import LoadingFallback from './utils/loadingFallback';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import 'simplebar/dist/simplebar.min.css';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './redux/Store'
import { App } from './App';
import { AppErrorFallback } from './components/system/AppErrorFallback';
import './App.css';

window.onerror = (message, error) => {
  CustomErrorLogger(error || new Error(message), "Global Error");
};

window.addEventListener("unhandledrejection", (event) => {
  CustomErrorLogger(event.reason, "Unhandled Promise Rejection");
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <ErrorBoundary
            FallbackComponent={AppErrorFallback}
            onError={(error, info) => {
              CustomErrorLogger(error);
              console.error("ErrorBoundary caught an error", info);
            }}
          >
            <Suspense fallback={<LoadingFallback />}>
              <App />
            </Suspense>
          </ErrorBoundary>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  </React.StrictMode >,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();